import React from 'react';
import styled, { useTheme } from 'styled-components';

// Styled Components
const Card = styled.div`
  background-color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors.card.background
      : '#f8fafc'};
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? props.theme.colors.card.border : '#e2e8f0'};
  text-align: center;
`;

const Value = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.primary};
  margin-bottom: 0.5rem;
`;

const Label = styled.div`
  font-size: 0.875rem;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors.text.light
      : props.theme.colors.secondary};
  font-weight: 500;
`;

const Skeleton = styled.div`
  height: 32px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'linear-gradient(90deg, rgba(255,255,255,0.05) 25%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 75%)'
      : 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)'};
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  width: ${(props) => props.width || '80px'};
  margin: 0 auto 0.5rem auto;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const MetricCard = ({
  loading = false,
  value,
  label,
  skeletonWidth = '80px',
}) => {
  const theme = useTheme();

  return (
    <Card theme={theme}>
      {loading ? (
        <>
          <Skeleton width={skeletonWidth} theme={theme} />
          <Label theme={theme}>{label}</Label>
        </>
      ) : (
        <>
          <Value theme={theme}>{value}</Value>
          <Label theme={theme}>{label}</Label>
        </>
      )}
    </Card>
  );
};

export default MetricCard;
